export async function DecryptedAES(base64CipherText) {
  try {
    if (!base64CipherText || typeof base64CipherText !== "string") {
      console.error("Decryption error: input is undefined or not a string", base64CipherText);
      return null;
    }

    function base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64.replace(/(\r\n|\n|\r)/gm, ""));
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes;
    }

    const rawData = base64ToArrayBuffer(base64CipherText);
    const iv = rawData.slice(0, 12);
    const ciphertext = rawData.slice(12);

    const keyBytes = new TextEncoder().encode("0123456789abcdef");
    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyBytes,
      { name: "AES-GCM" },
      false,
      ["decrypt"]
    );

    const decryptedBuffer = await window.crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      cryptoKey,
      ciphertext.buffer
    );

    return new TextDecoder().decode(decryptedBuffer);
  } catch (err) {
    console.error("AES-GCM decryption failed:", err);
    return null;
  }
}
